import React, { Component } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import './style.css';

class TeacherPendingReservation extends Component {
  handleConfirmReservation = (reservation) => {
    this.props.onConfirm(reservation);
  }

  render() {
    const { reservation, source } = this.props;
    const startTime = moment(reservation.startTime);
    const endTime = startTime.clone().add(reservation.duration, 'minutes');

    return (
      <div className="teacher-pending-reservation px-5 py-4 mb-4">
        <p className="teacher-pending-reservation__service mb-2">{reservation.service.description}</p>
        <div className="d-flex">
          <div style={{ flex: 1 }}>
            <div className="row">
              <div
                id={`teacher-pending-reservation__time`}
                className={classnames(
                  {
                    'col-12 col-xl-7 col-lg-12 col-md-7 col-sm-12': source === 'home'
                  },
                  {
                    'col-12 col-md-7 col-sm-7': source === 'schedule'
                  }
                )}
              >
                <h5 className="teacher-pending-reservation__time-text">{`${startTime.format(
                  'h:mma'
                )} - ${endTime.format('h:mma')}`}
                </h5>
                <button
                  type="button"
                  className="btn btn-blue btn-cursor btn-sm px-4 py-2 my-2"
                  onClick={() => this.handleConfirmReservation(reservation)}
                >
                  Confirm
                </button>
              </div>
              <div
                id={`teacher-pending-reservation__name`}
                className={classnames(
                  { 'col-12 col-xl-5 col-lg-12 col-md-5 col-sm-12': source === 'home' },
                  { 'col-12 col-md-5 col-sm-5': source === 'schedule' }
                )}
              >
                <h5 className="teacher-pending-reservation__name">{reservation.student.name}</h5>
                <p className="mb-4">{`Skype: ${reservation.student.skypeName}`}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TeacherPendingReservation;



// WEBPACK FOOTER //
// ./src/components/TeacherPendingReservation/index.js